




























































import { Component, Vue, Watch } from "vue-property-decorator";
import { auth } from "@/config/host.config";
import { IActivityStatus as IUser } from "@/@types/admin/activity-status";
import { accessPermissions } from "@/services/accessDecoder";
import { isGuestRuleHidden } from "@/services/featureConfig";
import { ServersCode } from "@/config/servers-code.config";
import { GuestRules, UserRoles } from "@/api/AuthAPI/user-role";
import { deleteElement } from "@/api/delite/delite-element";

import UserAdministrationList from "@/components/tables/administration/user-administration-list.vue";
import TvAdministrationList from "@/components/tables/administration/tv-administration-list.vue";
import StandartUserModal from "@/components/tables/administration/standart-user-modal.vue";
import UsersControl from "@/components/forms/users/users-control.vue";
import UserCreateModal from "@/components/forms/users/user-create-modal.vue";
import ButtonBack from "@/components/buttons/button-back.vue";

@Component({
  components: {
    UserAdministrationList,
    TvAdministrationList,
    StandartUserModal,
    UsersControl,
    UserCreateModal,
    ButtonBack,
  },
})
export default class AdministrationUsers extends Vue {
  userList: Array<IUser> = [];
  userRoles: Array<string> = Object.values(UserRoles);

  get rules(): Array<string> {
    return Object.values(GuestRules).filter((r) => !isGuestRuleHidden(r));
  }

  statusCode = "empty";
  search = "";

  tabUserIndex = 0;
  deleted = false;
  usersInterval: ReturnType<typeof setInterval> | undefined;
  user_id = "";

  get rule(): string {
    return this.rules[this.tabUserIndex];
  }

  get users(): Array<IUser> {
    const notRules: Array<string> = [
      GuestRules.tvuser,
      GuestRules.user,
      GuestRules.tabuser,
    ];
    let users: Array<IUser> = [];
    if (this.rule != "admins")
      users = this.userList.filter((user) => {
        if (user.rules == this.rule) return user;
      });
    else {
      users = this.userList.filter((user) => {
        if (!this.rules.includes(user.rules) && !notRules.includes(user.rules))
          return user;
      });
    }

    if (this.search) {
      const query = this.search.toLowerCase();
      return users.filter((item) => {
        return (
          item.login.toLowerCase().indexOf(query) > -1 ||
          item.tv_name.toLowerCase().indexOf(query) > -1 ||
          item.room_number.toLowerCase().indexOf(query) > -1
        );
      });
    }

    return users;
  }

  get user(): IUser | null {
    const user = this.userList.find((us) => us._id == this.user_id);
    return user ? user : null;
  }

  get canChange(): boolean {
    if (this.$isRoot()) return true;
    return accessPermissions(ServersCode.updateUser);
  }

  get isDeviceRule(): boolean {
    return this.rule == GuestRules.tvuser || this.rule == GuestRules.tabuser;
  }

  get isTablet(): boolean {
    return this.rule == GuestRules.tabuser;
  }

  get layout(): string {
    if (this.rule == "admins") return "user-administration-list";
    if (this.isDeviceRule) return "tv-administration-list";
    return "user-administration-list";
  }

  get deviceProps(): { [key: string]: string | boolean } {
    if (this.layout != "tv-administration-list") return {};
    return {
      deviceType: this.rule == GuestRules.tabuser ? "tablet" : "tv",
      showLinkedBlock: this.rule != GuestRules.tabuser,
    };
  }

  get userRulesList(): Array<string> {
    if (this.rule == GuestRules.tvuser) return [GuestRules.tvuser];
    if (this.rule == GuestRules.tabuser) return [GuestRules.tabuser];
    if (this.rule == GuestRules.user) return [GuestRules.user];
    if (this.rule == GuestRules.signuser) return [GuestRules.signuser];
    return Object.values(UserRoles);
  }

  async changeUser(data: Partial<IUser>, id: string): Promise<void> {
    if (this.isDeviceRule && !id) return;
    const method = id ? "put" : "post";

    let uri = "";
    if (this.isDeviceRule) uri = auth.user;
    if (id) uri = uri += `/${id}`;

    try {
      const res = await this.$axios[method](uri, data);
      if (res.status === 200) {
        this.user_id = "";
        const i = this.userList.findIndex((el) => el._id == id);
        if (i < 0) return this.getUsers();
        this.$set(this.userList, i, res.data);
        this.$bvModal.hide("guest-form-modal");
      }
    } catch (error) {
      console.log(error);
      this.onError(null);
    }
  }

  mustChangeUser(id: string): void {
    this.user_id = id;
    if (!id) return;

    const modal = this.isDeviceRule ? "guest-form-modal" : "user-create-modal";
    this.$nextTick(() => this.$bvModal.show(modal));
  }

  mustAddUser(): void {
    this.user_id = "";
    this.$nextTick(() => this.$bvModal.show("user-create-modal"));
  }

  onCreatedUserV2(user: IUser): void {
    if (user && user._id) this.userList.push(user);
    else this.getUsers();
  }

  onChangedUserV2(user: IUser): void {
    if (user && user._id) {
      const i = this.userList.findIndex((el) => el._id == user._id);
      if (i >= 0) this.$set(this.userList, i, user);
      else this.getUsers();
    } else this.getUsers();
    this.user_id = "";
  }

  onError(code: number | null): void {
    const text = code ? String(code) : "alerts.emptyUpdate";
    this.$notify({
      group: "global",
      text: String(this.$i18n.t(text)),
      type: "warn",
    });
  }

  onSuccess(code: string): void {
    const text = code ? code : "error.200";
    this.$notify({
      group: "global",
      text: String(this.$i18n.t(text)),
    });
  }

  openUser(id: string): void {
    this.user_id = id;
    this.$nextTick(() => this.$bvModal.show("standart-user-modal"));
  }

  deleteUsers(users: Array<string>): void {
    users.forEach((user) => this.deleteUser(user));
  }

  deleteUser(id: string): void {
    const uri = this.deleted ? auth.forseUser : auth.getUser;
    deleteElement(id, uri)
      .then(() => {
        this.onSuccess("Administration.errors.deleted-200");
        this.$bvModal.hide("standart-user-modal");
        this.clearUsers(id);
      })
      .catch(() => {
        this.onError(null);
      });
  }

  async clearUsers(id: string): Promise<void> {
    const i = this.userList.findIndex((user) => user._id == id);
    if (i < 0) return this.getUsers();
    this.userList.splice(i, 1);
  }

  async restoreUser(id: string): Promise<void> {
    if (!id) return this.onError(null);
    const uri = auth.restoreUser + "/" + id;
    try {
      const res = await this.$axios.put(uri);
      if (res.status === 200) {
        this.onSuccess("");
        this.clearUsers(id);
      }
    } catch (e) {
      this.onError(null);
    }
  }

  /**
   * @param notrules: без массива ролей @param rules: только 1 роль
   */
  @Watch("deleted")
  async getUsers(): Promise<void> {
    const params = {
      // notrules: [GuestRules.tvuser],
      // rules: GuestRules.tvuser,
      deleted: this.deleted,
    };

    try {
      const user_res = await this.$axios.get(auth.getUser, { params });
      if (user_res.status === 200) {
        if (!this.user) this.userList = user_res.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  mounted(): void {
    this.getUsers();
    this.usersInterval = setInterval(() => {
      this.getUsers();
    }, this.$second(10));
  }

  destroyed(): void {
    this.userList = [];

    this.statusCode = "";
    this.search = "";
    clearInterval(this.usersInterval);
  }
}
